
const digest = '4334af3e9610fc4f9e340cc14da53fba89b3c60de57b222a895df0634c0b0077';
const classes = {"wrapper":"_wrapper_ynnvl_1","col":"_col_ynnvl_7","colUser":"_col-user_ynnvl_12","colDate":"_col-date_ynnvl_23","colDetail":"_col-detail_ynnvl_35"};
const css = `._wrapper_ynnvl_1 {
  display: flex;
  flex-direction: row;
  padding: 12px 40px;
  background-color: #ffffff;
}
._wrapper_ynnvl_1 ._col_ynnvl_7 {
  font-weight: 400;
  font-size: 14px;
  color: #3e3f42;
}
._wrapper_ynnvl_1 ._col_ynnvl_7._col-user_ynnvl_12 {
  font-weight: 500;
  color: #000000;
}
._wrapper_ynnvl_1:first-of-type {
  padding-top: 24px;
}
._wrapper_ynnvl_1:last-of-type {
  padding-bottom: 24px;
}

._col-date_ynnvl_23 {
  min-width: 125px;
  max-width: 125px;
  margin-right: 40px;
}

._col-user_ynnvl_12 {
  min-width: 210px;
  max-width: 210px;
  margin-right: 40px;
}

._col-detail_ynnvl_35 {
  min-width: 385px;
  max-width: 385px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  